import { AspenPatientsService, PatientUpsertDTO, PatientUpsertResponseDTO } from '../client'
import { PaginatedDTO_PatientIndexDTO_ } from '../client/models/PaginatedDTO_PatientIndexDTO_'
import { usePaginatedData } from './usePaginatedData'

export const usePatients = (initialPage = 1, initialLimit = 10, initialSort = 'first_name:asc', initialFilters = {}) => {
    return usePaginatedData<PaginatedDTO_PatientIndexDTO_, PatientUpsertDTO, PatientUpsertResponseDTO>(
        AspenPatientsService.indexPatientsGet,
        initialPage,
        initialLimit,
        initialSort,
        initialFilters,
        AspenPatientsService.upsertPatientsPost
    )
}
